import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField, Autocomplete } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { FilterSwitches } from "./FilterSwitches";
import { useSearch } from "hooks/useSearch";
import { routesSelector } from "./selectors";
import { handleSubmit } from "./actions";
import { validateObject } from "helpers/validateObject";
import { newDate } from "helpers/dateTools";
import { routesTypes } from "helpers/dictionary";
import { persistLocalStorage } from "helpers/localstorageTool";
import { useValidateReload } from "hooks/useValidateReload";
import { useUpdateTabsInfo } from "hooks/useUpdateTabsInfo";
import {
  routesStatusInput,
  removeRouteShare
} from "redux/actions/routesStatus/routesStatusAction";

export default function StartEndRoutes() {
  const tableKey = "startEndRoutes";
  const dispatch = useDispatch();
  const routes = useSelector((state) => routesSelector(state));
  const { station, startDate, endDate, unit, isPinned, pinned } = useSelector(
    ({ routesStatus }) => routesStatus
  );
  const {
    setSnackbar,
    buildTableConfig,
    restoreTable,
  } = useSearch();
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const { value, cols } = validateObject(unit) && unit;
  const submit = (e) => {
    e && e.preventDefault();
    if (!station) return setSnackbar("Seleccione una Planta", "warning");
    handleSubmit(
      dispatch,
      startDate,
      endDate,
      station,
      value,
      setSnackbar,
      restoreTable
    );
  };

  const loadings = [
    "loadingRoutes",
    "loadingSettlement",
    "loadingPayments",
    "loadingRoutesActions",
  ];
  useValidateReload(loadings);

  const isSharing = (data = {}) => {
    if (data?.isSharing && data.route) {
      dispatch(removeRouteShare(data.route));
    }
  };

  useEffect(() => {
    localStorage.setItem("isLiquidation", false);
    !unit && dispatch(routesStatusInput("unit", routesTypes[0]));
    !configTables[tableKey] && buildTableConfig(tableKey);
    persistLocalStorage("route-share", { isSharing: false, route: null });
  }, []);

  useUpdateTabsInfo({
    storage: "route-share",
    action: isSharing
  });

  return (
    <>
      <CardTable
        hasHeader
        title={`Rutas tipo: ${unit?.label}`}
        blockBtn
        icon={<LocalShippingIcon />}
        data={isPinned ? pinned : routes}
        isLoading={isLoadingComp?.loadingRoutes}
        columns={cols || []}
        tableKey={tableKey}
        tableContent={
          <>
            <TableInputs
              reducer="routesStatus"
              dates
              maxDate={newDate()}
              stations
              dispatchAction={routesStatusInput}
              submitAction={submit}
            >
              <Grid item xs={12} sm={2}>
                <Autocomplete
                  id="combo-box-demo"
                  options={routesTypes}
                  value={unit}
                  getOptionLabel={(option) => option.label}
                  defaultValue={routesTypes[0]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipo"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  fullWidth
                  onChange={(e, v) => dispatch(routesStatusInput("unit", v))}
                  noOptionsText="No se encuentra el tipo de ruta"
                />
              </Grid>
            </TableInputs>
            <FilterSwitches tableKey={tableKey} />
          </>
        }
      />
    </>
  );
}
